import { TooltipWrapper } from "@/components/molecules/TooltipWrapper/TooltipWrapper";
import { Button, ButtonBar } from "@/overlay/components/CommonParts/buttons";
import { FormField } from "@/overlay/components/form-field";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import type { IsoInputField } from "./IsoLayerFormUtils";

export const ISO_SELECTION_TEST_IDS = {
  values: "IsoSelectionType-values-button",
  valueRange: "IsoSelectionType-value-range-button",
  isobandIntervals: "IsoSelectionType-isoband-intervals-button",
};

type IsoSelectionTypeSwitchProps = {
  selectedField: IsoInputField | null;
  onSelect: (field: IsoInputField) => void;
  withIsobandIntervals: boolean;
};

export function IsoSelectionTypeSwitch(props: IsoSelectionTypeSwitchProps) {
  const { selectedField, onSelect, withIsobandIntervals } = props;
  const tooltipText = withIsobandIntervals
    ? t`Select whether isobands should be defined by explicit values, ranges, or intervals.`
    : t`Select whether isolines should be defined by explicit values or ranges.`;

  return (
    <FormField
      label={
        <TooltipWrapper tooltipText={tooltipText} position="right" tail width={320}>
          <span>{t`Type`}</span>
        </TooltipWrapper>
      }
      noSemanticLinking={true}
    >
      <ButtonBar pill>
        <Button
          active={selectedField === "values"}
          onClick={() => onSelect("values")}
          type="button"
          data-testid={ISO_SELECTION_TEST_IDS.values}
        >
          <Trans>Values</Trans>
        </Button>
        <Button
          active={selectedField === "value_range"}
          onClick={() => onSelect("value_range")}
          type="button"
          data-testid={ISO_SELECTION_TEST_IDS.valueRange}
        >
          <Trans>Ranges</Trans>
        </Button>
        {withIsobandIntervals && (
          <Button
            active={selectedField === "isoband_intervals"}
            onClick={() => onSelect("isoband_intervals")}
            type="button"
            data-testid={ISO_SELECTION_TEST_IDS.isobandIntervals}
          >
            <Trans>Intervals</Trans>
          </Button>
        )}
      </ButtonBar>
    </FormField>
  );
}
